export const DEFAULT_THEME = {
  // config
  show_price: 0,
  payment_required: 0,
  inventory_exists: 0,

  // meta data
  meta_title: "",
  meta_description: "Your store description for SEO",
  favicon_url:
    "https://developmentprocureasy.s3.ap-south-1.amazonaws.com/products/verta_1754632506082.jpeg",

  // Global theme data
  store_name: "",
  company_logo:
    "https://content.swageazy.com/website/Logo-placeholder_1765185443514.png",
  company_banners: [" ", ""],

  login_page_image_url:
    "https://developmentprocureasy.s3.ap-south-1.amazonaws.com/products/loginpage_1754639867409.png",
  empty_cart_image_url:
    "https://developmentprocureasy.s3.ap-south-1.amazonaws.com/products/Group-1171275071_1754633363723.png",

  store_background_color: "#f5f5f5",
  navbar_shadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
  footer_text: "",
  text_color: "#333",
  hover_text_color: "#2563eb",
  app_text: "#333",
  app_grey: "#666",
  app_button_color: "#e74c3c",
  app_hover_button_color: "#d62d1a",
  app_button_text_color: "white",
  app_button_secondary_color: "#000000",
  app_button_secondary_hover_color: "#000000",
  app_button_secondary_text_color: "white",
  app_button_tertiary_color: "#000000",
  app_button_tertiary_hover_color: "#000000",
  app_button_tertiary_text_color: "white",
  card_bg_color: "#ffffff",
  active_textfield_color: "#000000",
  disabled_textfield_color: "#666",
  error_textfield_color: "#e74c3c",
  divider: "#e0e0e0",
  // Homepage
  homepage_product_heading: "All Products",
  homepage_product_card_background: "#ffffff",
  homepage_product_name_background: "#f8f9fa",
  // Product Details
  product_details_price_color: "#e74c3c",
  product_details_quantity_background: "#f5f5f5",
  product_details_carousal_background: "#ffffff",
  product_details_card_background: "#ffffff",
  skeleton_background: "#f5f5f5",
  company_name: "",
  navbar_background_color: "#ffffff",
};

class ThemeManager {
  constructor() {
    this.settings = { ...DEFAULT_THEME };
  }
  setSettings(settings) {
    this.settings = { ...DEFAULT_THEME, ...(settings || {}) };
  }
  getValue(key) {
    return this.settings[key];
  }
}

const themeManager = new ThemeManager();
export default themeManager;
